
import { useLanguage } from '@/hooks/useLanguage';
import { NewsCard } from './NewsCard';
import { NewsItem } from '@/hooks/useNewsFeed';
import { motion, AnimatePresence } from 'framer-motion';

interface NewsGridProps {
  newsItems: NewsItem[];
  formatDate: (dateString: string) => string;
}

export function NewsGrid({ newsItems, formatDate }: NewsGridProps) {
  const { t } = useLanguage();

  if (newsItems.length === 0) {
    return (
      <div className="text-center py-20">
        <p className="text-muted-foreground text-lg">{t('news.noResults')}</p>
      </div>
    );
  }

  return (
    <motion.div
      layout
      className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6"
    >
      <AnimatePresence mode="popLayout">
        {newsItems.map((item, index) => (
          <NewsCard
            key={item.id || index}
            item={item}
            index={index}
            formatDate={formatDate}
          />
        ))}
      </AnimatePresence>
    </motion.div>
  );
}
